<template>
  <div>
    <div
      class="modal-container d-flex align-items-center justify-content-center"
    >
      <div class="modal-body">
        <div class="d-flex justify-content-end mb-4 close" @click="closeModal">
          X
        </div>
        <div class="form-container w-75">
          <form v-on:submit="editGroup">
            <!-- 2. Description -->
            <div class="d-flex mb-2">
              <div class="w-50 flex-grow">Description</div>
              <input
                v-model="form.Description"
                class="form-control"
                placeholder="description"
              />
            </div>

            <!-- 3. API Keys -->
            <div class="d-flex mb-2">
              <div class="w-50 flex-grow">API Keys</div>
              <div class="input-group">
                <input
                  v-model="form.apiKeys"
                  type="text"
                  class="form-control"
                  placeholder="key1,key2,key3 - if nothing put []"
                />
              </div>
            </div>

            <!-- 4. DB Access Rights -->
            <div class="d-flex mb-2">
              <div class="w-50 flex-grow">DB Access Rights</div>
              <div class="input-group">
                <input
                  v-model="form.DBAccessRights"
                  type="text"
                  class="form-control"
                  placeholder="db1,db2,db3 - if nothing put []"
                />
              </div>
            </div>

            <!-- Submit button -->
            <div class="d-flex justify-content-center gap-4">
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="Object.keys(changedField).length == 0"
              >
                Edit Information
              </button>
              <button @click="reset" class="btn btn-secondary">Reset</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api.js";

export default {
  setup() {},
  props: {
    group: Object,
  },
  emits: ["closeModal", "updateGroup"],
  methods: {
    async editGroup(e) {
      if (e) {
        e.preventDefault();
      }

      // check for errors
      for (const [key, value] of Object.entries(this.form)) {
        if (!value) {
          alert(`please fill in a valid input for [ ${key} ] !!`);
          return false;
        }
      }
      this.changedField.GroupName = this.group.GroupName;
      // cleanup data
      if (this.changedField["apiKeys"]) {
        if (this.changedField["apiKeys"] == "[]")
          this.changedField["apiKeys"] = [];
        else
          this.changedField["apiKeys"] =
            this.changedField["apiKeys"].split(",");

        this.changedField["APIKeys"] = this.changedField["apiKeys"];
        delete this.changedField["apiKeys"];
      } else {
        this.changedField["APIKeys"] = this.group["apiKeys"];
      }

      if (this.changedField["DBAccessRights"]) {
        if (this.changedField["DBAccessRights"] == "[]")
          this.changedField["DBAccessRights"] = [];
        else {
          this.changedField["DBAccessRights"] =
            this.changedField["DBAccessRights"].split(",");
        }
      } else {
        this.changedField["DBAccessRights"] = this.group["DBAccessRights"];
      }

      try {
        var res = await api.editGroup(this.changedField);
        alert("Successfully modified user's information");
        this.closeModal();
      } catch (e) {
        alert(e.message.response.data);
        return false;
      }
      this.$emit("updateGroup");
      return res;
    },
    closeModal() {
      this.$emit("closeModal");
    },
    reset(e) {
      e.preventDefault();
      this.form = Object.create(this.group);
      if (!this.form["apiKeys"] || this.form["apiKeys"].length == 0) {
        this.form["apiKeys"] = "[]";
      }
      if (
        !this.form["DBAccessRights"] ||
        this.form["DBAccessRights"].length == 0
      ) {
        this.form["DBAccessRights"] = "[]";
      }
    },
  },
  mounted() {
    this.form = Object.create(this.group);
    if (!this.form["apiKeys"] || this.form["apiKeys"].length == 0) {
      this.form["apiKeys"] = "[]";
    } else {
      this.form["apiKeys"] = this.form["apiKeys"].join(",");
    }
    if (
      !this.form["DBAccessRights"] ||
      this.form["DBAccessRights"].length == 0
    ) {
      this.form["DBAccessRights"] = "[]";
    } else {
      this.form["DBAccessRights"] = this.form["DBAccessRights"].join(",");
    }
  },
  data() {
    return {
      form: {},
      changedField: {},
    };
  },
  watch: {
    "form.Description"(val) {
      if (val !== this.group.Description) {
        this.changedField.Description = val;
      } else {
        delete this.changedField.Description;
      }
    },
    "form.apiKeys"(val) {
      if (
        val !==
        (!this.group["apiKeys"] || this.group.apiKeys.length == 0
          ? "[]"
          : this.group.apiKeys.join(","))
      ) {
        this.changedField.apiKeys = val;
      } else {
        delete this.changedField.apiKeys;
      }
    },
    "form.DBAccessRights"(val) {
      if (
        val !==
        (!this.group["DBAccessRights"] || this.group.DBAccessRights.length == 0
          ? "[]"
          : this.group.DBAccessRights.join(","))
      ) {
        this.changedField.DBAccessRights = val;
      } else {
        delete this.changedField.DBAccessRights;
      }
    },
  },
};
</script>

<style scoped>
.modal-container {
  z-index: 2;
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.modal-body {
  position: absolute;
  width: 80%;
  background: white;
  border-radius: 20px;
  padding: 30px;
  padding-bottom: 50px;
}
.form-select {
  margin-left: 6px;
}
.input-group {
  margin-left: -3px;
}
.form-container {
  width: fit-content;
  margin: 0 auto;
}
#text-console {
  margin: auto auto;
  text-align: left;
  width: 100%;
  height: 100%;
  border: solid;
}
#copy-button {
  cursor: pointer;
}
.close {
  cursor: pointer;
}
</style>
